// Mock data for The Asphalt Edge

export const categories = [
  {
    id: 1,
    name: "Helmets",
    image: "https://images.unsplash.com/photo-1558980664-769d59546b3d?w=800&q=80",
    description: "Premium LS2 & Axor helmets. ECE 22.06 certified.",
    badge: "360° View",
    inStock: 24
  },
  {
    id: 2,
    name: "Jackets",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=800&q=80",
    description: "Abrasion-resistant riding jackets with CE armor inserts.",
    badge: "360° View",
    inStock: 15
  },
  {
    id: 3,
    name: "Pants",
    image: "https://images.unsplash.com/photo-1604933762021-57a5f8bbf90c?w=800&q=80",
    description: "Reinforced riding pants with hip and knee protection.",
    badge: "360° View",
    inStock: 12
  },
  {
    id: 4,
    name: "Riding Gloves",
    image: "https://images.unsplash.com/photo-1578632292335-df3abbb0d586?w=800&q=80",
    description: "All-weather protection with CE-rated knuckle guards.",
    badge: "360° View",
    inStock: 18
  },
  {
    id: 5,
    name: "Bike Carrier Boxes",
    image: "https://images.unsplash.com/photo-1609630875171-b1321377ee65?w=800&q=80",
    description: "Durable storage solutions for long rides.",
    badge: "360° View",
    inStock: 12
  },
  {
    id: 6,
    name: "Boots",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&q=80",
    description: "Ankle-protection riding boots for all terrain types.",
    badge: "360° View",
    inStock: 10
  },
  {
    id: 7,
    name: "Communication Devices",
    image: "https://images.unsplash.com/photo-1484704849700-f032a568e944?w=800&q=80",
    description: "Bluetooth intercoms and helmet communication systems.",
    badge: "360° View",
    inStock: 8
  },
  {
    id: 8,
    name: "Hard Parts",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
    description: "Performance parts and accessories for your ride.",
    badge: "360° View",
    inStock: 20
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    role: "Verified Rider",
    rating: 5,
    text: "Got my LS2 helmet here weeks before it hit other stores. The fitting session was incredibly detailed. This isn't just a shop - it's an experience.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&q=80",
    verified: true
  },
  {
    id: 2,
    name: "Priya Desai",
    role: "Verified Rider",
    rating: 5,
    text: "The staff knows their gear inside out. They helped me pick the perfect jacket for my riding style. The after-sales support is unmatched.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&q=80",
    verified: true
  },
  {
    id: 3,
    name: "Amit Kulkarni",
    role: "Verified Rider",
    rating: 5,
    text: "First-class showroom with the latest collections. I travel from Mumbai just to shop here. Worth every kilometer!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&q=80",
    verified: true
  }
];

export const certifications = [
  {
    id: 1,
    name: "ECE 22.06",
    description: "European safety standard for motorcycle helmets. Includes rotational impact testing and extended coverage areas.",
    icon: "Shield",
    year: "2023"
  },
  {
    id: 2,
    name: "DOT",
    description: "US Department of Transportation certification. Ensures helmets meet minimum safety performance requirements.",
    icon: "BadgeCheck",
    year: "Current"
  },
  {
    id: 3,
    name: "ISI Mark",
    description: "Indian Standards certification for motorcycle protective gear. Mandatory for sale in India.",
    icon: "Award",
    year: "Current"
  }
];

export const uvpFeatures = [
  {
    id: 1,
    title: "First to Drop",
    description: "We stock new collections weeks before competitors. Get your hands on the latest gear while others are still waiting.",
    icon: "Zap"
  },
  {
    id: 3,
    title: "Expert Fitting",
    description: "Personalized gear fitting sessions with certified specialists. Because protection starts with the perfect fit.",
    icon: "UserCheck"
  },
  {
    id: 4,
    title: "Premium Brands",
    description: "Exclusive authorized dealer for LS2, Axor, and top international brands. Authenticity guaranteed.",
    icon: "Crown"
  }
];

export const showroomDetails = {
  address: "Kunal Icon Rd, beside Saibaba mandir, Kate Vasti Pimple Saudagar, Kunj Colony, Pimple Saudagar, Pimpri-Chinchwad, Maharashtra 411027",
  phone: "+919156800811",
  hours: "10 AM - 9 PM",
  daysOpen: "All 7 Days",
  mapUrl: "https://share.google/fq4Q9g8iNbe9gHIRs",
  coordinates: {
    lat: 18.5937,
    lng: 73.7997
  }
};
